import React, { useEffect, useState } from 'react';

import { Container, makeStyles } from '@material-ui/core';

import ReportViewer from '../../components/report-viewer/ReportViewer';

const useStyles = ({ fullScreen = false }) =>
  makeStyles((theme) => ({
    container: {
      height: fullScreen ? '100%' : '90vh',
      maxWidth: fullScreen ? '100%' : '95vw',
      padding: 0,
      width: fullScreen ? '100%' : '',
      [theme.breakpoints.down('sm')]: {
        height: '100%',
        maxWidth: '100%',
        width: '100%',
      },
    },
  }));

export default ({ fullScreen = false, reportViewerBloc, resources, token = null }) => {
  const classes = useStyles({ fullScreen })();
  const [selectedItem, setSelectedItem] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    const selectedItemSubscription = reportViewerBloc.selectedItem$.subscribe(setSelectedItem);
    const loadingSubscription = reportViewerBloc.loading$.subscribe(setLoading);
    const errorSubscription = reportViewerBloc.error$.subscribe(setError);

    return () => {
      selectedItemSubscription.unsubscribe();
      loadingSubscription.unsubscribe();
      errorSubscription.unsubscribe();
    };
  }, [reportViewerBloc]);

  useEffect(() => {
    if (!selectedItem && resources?.length) {
      reportViewerBloc.setSelectedItem(resources[0], token).then();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resources, token]);

  const handleItemClick = async (item) => {
    await reportViewerBloc.setSelectedItem(item, token);
  };

  const handleCloseDialog = () => reportViewerBloc.closeDialog();

  return (
    <Container className={classes.container}>
      <ReportViewer
        fullScreen={fullScreen}
        resources={resources}
        onClick={handleItemClick}
        selectedItem={selectedItem}
        loading={loading}
        errorMessage={error}
        onClose={handleCloseDialog}
        isRecorder
      />
    </Container>
  );
};
